"use strict";
/**
 * The «Note spese» module's expense categories (decision 130, #497), shared by the module that
 * stores expenses and by the receipt prefill that proposes one.
 *
 * SEEDED FROM NEXPENSE (#497, nexpense main @ 72d473f): its 24 live types with their Italian UI
 * labels and hints, and the report type each belongs to. Its deprecated «Meals» is left out: it was
 * migrated to `EntertainmentMeals` and has no uses. `nexpenseCode` maps nexpense's code to the
 * console's for the migration of past expenses.
 *
 * NO DEDUCTIBILITY HERE. nexpense's rates were never validated with the tax adviser and differ from
 * the company rules in the study, so they wait for that review (spec open point 4) rather than
 * entering as if they were tax truth.
 *
 * A CONSTANT FOR RELEASE 1. When the administration office can edit the list, the module serves it
 * from its own table and this stays the seed.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPENSE_CATEGORY_CODES = exports.EXPENSE_CATEGORIES = exports.EXPENSE_REPORT_TYPES = void 0;
exports.pickableExpenseCategories = pickableExpenseCategories;
exports.expenseCategoryByCode = expenseCategoryByCode;
exports.expenseCategoryByNexpenseCode = expenseCategoryByNexpenseCode;
exports.EXPENSE_REPORT_TYPES = ['travel', 'reimbursement'];
exports.EXPENSE_CATEGORIES = [
    {
        code: 'lodging',
        labelIt: 'Alloggio',
        labelEn: 'Lodging',
        hintIt: 'Hotel, ostelli, B&B, affitti a breve termine',
        reportType: 'travel',
        nexpenseCode: 'Lodging',
    },
    {
        code: 'travel-meals',
        labelIt: 'Pasti di viaggio',
        labelEn: 'Travel meals',
        hintIt: 'Pasti durante viaggi di lavoro e conferenze',
        reportType: 'travel',
        nexpenseCode: 'TravelMeals',
    },
    {
        code: 'entertainment-meals',
        labelIt: 'Pasti di rappresentanza',
        labelEn: 'Entertainment meals',
        hintIt: 'Pasti aziendali con clienti, cene con potenziali clienti',
        reportType: 'travel',
        nexpenseCode: 'EntertainmentMeals',
    },
    {
        code: 'work-meals',
        labelIt: 'Pasti di lavoro',
        labelEn: 'Work meals',
        hintIt: 'Pasti di lavoro, riunioni di team, pasti aziendali interni',
        reportType: 'travel',
        nexpenseCode: 'WorkMeals',
    },
    {
        code: 'entertainment',
        labelIt: 'Spese di rappresentanza',
        labelEn: 'Entertainment',
        hintIt: 'Eventi di intrattenimento aziendale, team building',
        reportType: 'travel',
        nexpenseCode: 'Entertainment',
    },
    {
        code: 'transportation',
        labelIt: 'Trasporto',
        labelEn: 'Transportation',
        hintIt: 'Voli, treni, autobus, taxi, noleggio auto',
        reportType: 'travel',
        nexpenseCode: 'Transportation',
    },
    {
        code: 'travel-fees',
        labelIt: 'Tasse di viaggio',
        labelEn: 'Travel fees',
        hintIt: 'Visti, assicurazione di viaggio, tasse bagagli',
        reportType: 'travel',
        nexpenseCode: 'TravelFees',
    },
    {
        code: 'fuel',
        labelIt: 'Carburante',
        labelEn: 'Fuel',
        hintIt: 'Benzina, diesel, ricarica veicoli elettrici',
        reportType: 'travel',
        nexpenseCode: 'Fuel',
    },
    {
        code: 'parking',
        labelIt: 'Parcheggio',
        labelEn: 'Parking',
        hintIt: 'Parcheggi, garage',
        reportType: 'travel',
        nexpenseCode: 'Parking',
    },
    {
        code: 'road-charges',
        labelIt: 'Pedaggi stradali',
        labelEn: 'Road charges',
        hintIt: 'Pedaggi autostradali, tasse di congestione',
        reportType: 'travel',
        nexpenseCode: 'RoadCharges',
    },
    {
        code: 'mileage-reimbursement',
        labelIt: 'Rimborso chilometrico',
        labelEn: 'Mileage reimbursement',
        hintIt: 'Uso del veicolo personale, in base alla distanza',
        reportType: 'travel',
        nexpenseCode: 'MileageReimbursement',
    },
    {
        // Added by wave 2, R-b: not a nexpense type. Only the note's allowance action adds one.
        code: 'flat-rate-allowance',
        // The same name as Gestione's setting and the console's screens (U13).
        labelIt: 'Forfettario trasferte',
        labelEn: 'Trip flat rate',
        hintIt: 'Diaria giornaliera della trasferta, aggiunta dalla nota',
        reportType: 'travel',
        nexpenseCode: 'FlatRateAllowance',
        serverManaged: true,
    },
    {
        code: 'supplies',
        labelIt: 'Forniture',
        labelEn: 'Supplies',
        hintIt: 'Materiali per ufficio, cancelleria',
        reportType: 'reimbursement',
        nexpenseCode: 'Supplies',
    },
    {
        code: 'equipment',
        labelIt: 'Attrezzature',
        labelEn: 'Equipment',
        hintIt: 'Hardware, dispositivi, attrezzature',
        reportType: 'reimbursement',
        nexpenseCode: 'Equipment',
    },
    {
        code: 'professional-services',
        labelIt: 'Servizi professionali',
        labelEn: 'Professional services',
        hintIt: 'Servizi legali, contabili, di consulenza',
        reportType: 'reimbursement',
        nexpenseCode: 'ProfessionalServices',
    },
    {
        code: 'telecommunications',
        labelIt: 'Telecomunicazioni',
        labelEn: 'Telecommunications',
        hintIt: 'Telefonia, internet, dati mobili',
        reportType: 'reimbursement',
        nexpenseCode: 'Telecommunications',
    },
    {
        code: 'gifts',
        labelIt: 'Regali',
        labelEn: 'Gifts',
        hintIt: 'Regali aziendali, articoli promozionali',
        reportType: 'reimbursement',
        nexpenseCode: 'Gifts',
    },
    {
        code: 'digital-services',
        labelIt: 'Servizi digitali',
        labelEn: 'Digital services',
        hintIt: 'Abbonamenti software, servizi cloud',
        reportType: 'reimbursement',
        nexpenseCode: 'DigitalServices',
    },
    {
        code: 'training',
        labelIt: 'Formazione',
        labelEn: 'Training',
        hintIt: 'Formazione, conferenze, certificazioni',
        reportType: 'reimbursement',
        nexpenseCode: 'Training',
    },
    {
        code: 'marketing',
        labelIt: 'Marketing',
        labelEn: 'Marketing',
        hintIt: 'Pubblicità, materiali ed eventi promozionali',
        reportType: 'reimbursement',
        nexpenseCode: 'Marketing',
    },
    {
        code: 'infrastructure',
        labelIt: 'Infrastruttura',
        labelEn: 'Infrastructure',
        hintIt: 'Affitto ufficio, utenze, manutenzione impianti',
        reportType: 'reimbursement',
        nexpenseCode: 'Infrastructure',
    },
    {
        code: 'regulatory-fees',
        labelIt: 'Tasse regolatorie',
        labelEn: 'Regulatory fees',
        hintIt: 'Licenze, permessi',
        reportType: 'reimbursement',
        nexpenseCode: 'RegulatoryFees',
    },
    {
        code: 'insurance',
        labelIt: 'Assicurazione',
        labelEn: 'Insurance',
        hintIt: 'Assicurazione aziendale, responsabilità professionale',
        reportType: 'reimbursement',
        nexpenseCode: 'Insurance',
    },
    {
        code: 'vehicle-expenses',
        labelIt: 'Spese per veicoli',
        labelEn: 'Vehicle expenses',
        hintIt: 'Manutenzione, assicurazione, leasing del veicolo',
        reportType: 'reimbursement',
        nexpenseCode: 'VehicleExpenses',
    },
    {
        code: 'other',
        labelIt: 'Altro',
        labelEn: 'Other',
        hintIt: 'Spese non coperte dai tipi standard',
        reportType: 'reimbursement',
        nexpenseCode: 'Other',
    },
];
exports.EXPENSE_CATEGORY_CODES = exports.EXPENSE_CATEGORIES.map((category) => category.code);
/** The categories a person may pick, on a form or from a receipt: the server-managed ones left out. */
function pickableExpenseCategories(categories = exports.EXPENSE_CATEGORIES) {
    return categories.filter((category) => category.serverManaged !== true);
}
function expenseCategoryByCode(code) {
    return exports.EXPENSE_CATEGORIES.find((category) => category.code === code);
}
function expenseCategoryByNexpenseCode(nexpenseCode) {
    return exports.EXPENSE_CATEGORIES.find((category) => category.nexpenseCode === nexpenseCode);
}
//# sourceMappingURL=expense-categories.js.map